import icon from 'assets/img/icons/success-green-big.svg'
import { useRefreshItems } from 'hooks/useRefreshItems';

const SellPopupSuccess = ({ closePopup }) => {
  const refresh = useRefreshItems();

  return (
    <div className='modal-window__wrapper' onClick={(e) => e.stopPropagation()}>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Success!</h5>
        <p className="modal-window__info">Your card is now listed for sale.</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close"
          onClick={() => {
            closePopup();
            refresh();
            window.scrollTo(0, 0);
          }}
        >Cancel</button>
        <button className="modal-window__footer-submit"
          onClick={() => {
            closePopup();
            refresh();
            window.scrollTo(0, 0);
          }}>Done</button>
      </footer>
    </div>
  )
}

export default SellPopupSuccess;
